export const displayCustomerDetails = (customerId) => {
  document.getElementById("sale_invoice_form_customer_id").value = customerId;
  document.getElementById("invoice_hidden_btn_clients").click();
};
